import * as React from "react";
const SvgFiRrArrowUpLeftFromCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-up-left-from-circle_svg__a)">
      <path
        fill="#062147"
        d="M2 3.414V10a1 1 0 0 1-2 0V3c0-1.654 1.346-3 3-3h7a1 1 0 0 1 0 2H3.414l12.293 12.293a.999.999 0 1 1-1.414 1.414zM14 4a10 10 0 0 0-3.333.569 1 1 0 1 0 .667 1.885 8 8 0 0 1 2.667-.455c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8c0-.915.153-1.812.455-2.667a1 1 0 0 0-1.885-.667 10 10 0 0 0-.569 3.333c0 5.514 4.486 10 10 10s10-4.486 10-10S19.514 4 14 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-up-left-from-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowUpLeftFromCircle;
